module.exports = __webpack_public_path__ + "img/container.0a59f51e.png";